<template>
  <v-dialog
    v-model="show"
    :max-width="max_width"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col>
              <v-text-field
                v-model="item.supplier"
                :label="$t(nameLabel)"
              >
                <template
                  #label
                  v-if="action==action_items.create"
                >
                  <span class="red--text"><strong>* </strong></span>{{ $t(nameLabel) }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close">{{ $t("cancel") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="action != action_items.view"
          color="primary"
          :disabled="disableSave"
          @click="saveSupplier"
        >{{ $t("save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "./BaseDialog";
export default {
  props: {},
  data: (vm) => ({
    topic: vm.$i18n.t("supplier.supplier"),
  }),
  computed: {
    nameLabel() {
      if (this.isTraditional === true) {
        return "supplier.name_tc";
      }
      return "supplier.name_sc";
    },
  },
  mixins: [BaseDialog],
  methods: {
    saveSupplier() {
      let editedItem = this._.cloneDeep(this.item);
      if (this.isTraditional === true) {
        editedItem.name_tc = this.item.supplier
      } else {
          editedItem.name_sc = this.item.supplier
      }
      this.$emit("onSave", editedItem);
    },
  },
};
</script>